import {runInAction} from 'mobx';

import {pollAsync} from '@yourcoach/async-utils';

import type {FileApiModel} from '../../../api/media/file';

import {fileStore} from '../../../api/media/file';
import {getEntityTypeById} from '../getEntityType';

export const resolveFileIds = async (files: FileApiModel[]) => {
  const filesLength = files.length;
  const promises: Promise<string>[] = [];

  for (let i = 0; i < filesLength; i += 1) {
    const file = files[i]!;

    const isUploadedFile = getEntityTypeById(file._id) === 'file';

    if (isUploadedFile) {
      promises.push(Promise.resolve(file._id));
    } else {
      promises.push(
        new Promise(async (resolve, reject) => {
          try {
            const uploading = fileStore.uploading.get(file._id);

            if (uploading) {
              if (uploading.inProgress) {
                await pollAsync(() => uploading.inProgress === false);
              }

              if (uploading.success && uploading.file) {
                runInAction(() => {
                  files[i] = uploading.file!;
                });

                resolve(uploading.file._id);
              } else if (uploading.error) {
                const uploadedFile = await fileStore.upload(
                  file.src.original.url!,
                );

                runInAction(() => {
                  files[i] = uploadedFile;
                });

                resolve(uploadedFile._id);
              }
            }
          } catch (error) {
            reject(error);
          }
        }),
      );
    }
  }

  return await Promise.all(promises);
};
